import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../../context/GlobalContext";
import { sendAuctionOtp } from "../../api/api";
import { MobileNumberList } from "mobily-ui-library/lib";

class ActiveVoiceLines extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      rtl: false,
      activeVoiceLines: []
    }
  }

  componentDidMount = () => {
    this.setActiveVoiceLines()
  }

  setActiveVoiceLines = () => {
    const [context] = this.context;
    const activeVoiceLinesData = context.activeVoiceLines
    const activeVoiceLines = activeVoiceLinesData.map(data => {
      return {
        msisdn: data.msisdn,
        maskedMSISDN: data.msisdnMasked,
        san: data.san
      }
    })

    this.setState({
      rtl: context.rtl,
      activeVoiceLines
    })
  }

  handleSendCode = async (value) => {
    const [context, dispatch] = this.context;
    const orderId = new Date().getTime()
    const sendAuctionOtpResponse = await sendAuctionOtp(value.msisdn, "Mobily", value.san, orderId);
    
    dispatch({
      type: 'UPDATE_ACTIVE_VOICE_NUM',
      payload: { 
        mobileNum: value.msisdn,
        otpType: "Mobily",
        orderId: orderId,
        serviceRequestID: sendAuctionOtpResponse?.data?.data?.serviceRequestID
       }
    })
    dispatch({
      type: 'GO_TO_SCREEN',
      payload: { profileUpdateScreen: "AbsherOtp" }
    })
  }

  render() {
    const { t } = this.props;
    const { rtl, activeVoiceLines } = this.state;
    
    return (
      <div className="activeVoiceLines">
        <div className="pu_subheading">{t("active_voice_lines_subheading")}</div>
        <div>
          <MobileNumberList
            rtl={rtl}
            buttonText={t('send_code')}
            data={activeVoiceLines}
            onClick={this.handleSendCode}
          />
        </div>
        <p>{t("active_voice_lines_end_text")}</p>
      </div>
    )
  }
}

export default withTranslation()(ActiveVoiceLines);